import {
  LogLevel,
  Configuration,
  BrowserCacheLocation,
  IPublicClientApplication,
  PublicClientApplication, InteractionType
} from '@azure/msal-browser';
import {MsalGuardConfiguration, MsalInterceptorConfiguration} from "@azure/msal-angular";
import {environment} from "../../../environments/environment";

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function instancePublicClientApp(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azureb2c.clientId,
      authority: environment.azureb2c.authorityUrl,
      knownAuthorities: [ environment.azureb2c.authorityDomain ],
      redirectUri: environment.azureb2c.redirectUri,
      postLogoutRedirectUri: environment.azureb2c.postLogoutRedirectUri,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    }
  });
}

export function guardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
    loginFailedRoute: environment.azureb2c.postLogoutRedirectUri
  };
}

export function interceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  protectedResourceMap.set(protectedResources.api.endpoint, protectedResources.api.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export const protectedResources = {
  api: {
    endpoint: environment.envApiUrl,
    scopes: environment.azureb2c.scopes
  }
};
export const loginRequest = {
  scopes: environment.azureb2c.scopes
};
